import { render } from "./input-editor.component.vue?vue&type=template&id=3d6ad734"
import script from "./input-editor.component.vue?vue&type=script&lang=js"
export * from "./input-editor.component.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./input-editor.component.vue?vue&type=style&index=0&id=3d6ad734&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__
import QEditor from 'quasar/src/components/editor/QEditor.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QEditor});
